export default __webpack_public_path__ + "static/media/image-outline.201e9cca.svg";